<template>
  <v-toolbar color="primary" app>
    <v-btn flat v-if="back" color="white" @click="returnToPreviousPage()">
      <v-icon large>keyboard_arrow_left</v-icon>
    </v-btn>
    <h2 class="title white--text font-weight-regular">
      {{ headerText | translate }}
    </h2>
  </v-toolbar>
</template>

<script>
import router from "./../router.js";

export default {
  name: "Header",
  data() {
    return {
      //
    };
  },
  props: {
    headerText: {
      type: String,
      default: ""
    },
    back: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    returnToPreviousPage() {
      router.go(-1);
    }
  }
};
</script>
